import { useState }        from 'react';
import { useNavigate }     from 'react-router-dom';
import { useTabsStore }    from '../store/tabsStore.js';
import { useCartStore }    from '../store/cartStore.js';
import { IcoTabs, IcoUser, IcoClose } from '../components/common/Icons.jsx';
import styles from './TabsScreen.module.css';

const fmt     = (n) => `$${Number(n ?? 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`;
const fmtTime = (iso) => new Date(iso).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });

export default function TabsScreen() {
  const navigate      = useNavigate();
  const tabs          = useTabsStore((s) => s.tabs);
  const activeTabId   = useTabsStore((s) => s.activeTabId);
  const setActiveTab  = useTabsStore((s) => s.setActiveTab);
  const closeTab      = useTabsStore((s) => s.closeTab);
  const replaceCart   = useCartStore((s) => s.replaceCart);
  const cartItems     = useCartStore((s) => s.items);

  const [confirmDelete, setConfirmDelete] = useState(null); // tab id

  const tabTotal = (tab) =>
    Math.max(0, tab.items.reduce((s, i) => s + i.total, 0) - (tab.discount ?? 0));

  const openTab = (tab) => {
    if (cartItems.length > 0 && tab.id !== activeTabId) {
      if (!window.confirm('El carrito actual se reemplazará con esta cuenta. ¿Continuar?')) return;
    }
    replaceCart(tab);
    setActiveTab(tab.id);
    navigate('/');
  };

  const handleDelete = (id) => {
    closeTab(id);
    setConfirmDelete(null);
  };

  return (
    <div className={styles.root}>
      <div className={styles.inner}>

        <div className={styles.header}>
          <button className="btn btn--ghost" onClick={() => navigate('/')}>← Volver</button>
          <h1 className={styles.title}>Cuentas abiertas</h1>
        </div>

        {tabs.length === 0 ? (
          <div className={styles.empty}>
            <p className={styles.emptyIcon}><IcoTabs size={40} /></p>
            <p className={styles.emptyTitle}>Sin cuentas abiertas</p>
            <p className={styles.emptyText}>
              Guarda el carrito como cuenta para cobrar más tarde o manejar varias mesas a la vez.
            </p>
            <button className="btn btn--primary" style={{ marginTop: 16 }} onClick={() => navigate('/')}>
              Ir al catálogo
            </button>
          </div>
        ) : (
          <div className={styles.list}>
            {tabs.map((tab) => {
              const isActive  = activeTabId === tab.id;
              const itemCount = tab.items.reduce((s, i) => s + i.quantity, 0);
              return (
                <div key={tab.id} className={`${styles.card} ${isActive ? styles.cardActive : ''}`}>
                  <div className={styles.cardLeft}>
                    <div className={styles.cardName}>
                      {tab.name}
                      {isActive && <span className={styles.activePill}>Editando</span>}
                    </div>
                    <div className={styles.cardMeta}>
                      {itemCount} artículo{itemCount !== 1 ? 's' : ''} · {fmtTime(tab.createdAt)}
                      {tab.customer && <span> · <IcoUser size={12} /> {tab.customer.name}</span>}
                    </div>
                    <div className={styles.cardItems}>
                      {tab.items.slice(0, 3).map((i) => i.product?.name ?? i.name).join(', ')}
                      {tab.items.length > 3 ? ` +${tab.items.length - 3}` : ''}
                    </div>
                  </div>
                  <div className={styles.cardRight}>
                    <strong className={styles.cardTotal}>{fmt(tabTotal(tab))}</strong>
                    <div className={styles.cardActions}>
                      <button
                        className="btn btn--primary"
                        style={{ fontSize: 13, padding: '0 14px', minHeight: 36 }}
                        onClick={() => openTab(tab)}
                      >
                        {isActive ? 'Continuar' : 'Abrir'}
                      </button>
                      {confirmDelete === tab.id ? (
                        <div className={styles.confirmRow}>
                          <button className="btn btn--danger" style={{ fontSize: 12, minHeight: 32 }} onClick={() => handleDelete(tab.id)}>Eliminar</button>
                          <button className="btn btn--ghost"  style={{ fontSize: 12, minHeight: 32 }} onClick={() => setConfirmDelete(null)}>Cancelar</button>
                        </div>
                      ) : (
                        <button
                          className="btn btn--ghost"
                          style={{ fontSize: 12, padding: '0 10px', minHeight: 36 }}
                          onClick={() => setConfirmDelete(tab.id)}
                          title="Eliminar cuenta"
                        >
                          <IcoClose size={13} />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
